import { z } from 'zod';
import { handleSchema, passwordSchema, ukPhoneSchema } from './common.js';
/** The 12 UK home regions. Single source of truth — the client picker imports this. */
export const UK_REGIONS = [
    'East Midlands',
    'East of England',
    'London',
    'North East',
    'North West',
    'South East',
    'South West',
    'West Midlands',
    'Yorkshire',
    'Scotland',
    'Wales',
    'Northern Ireland',
];
export const ukRegionSchema = z.enum(UK_REGIONS);
export const BIO_MAX_CHARS = 160;
/**
 * displayName is deliberately NOT accepted — it mirrors the handle, set
 * server-side (S23 invariant). Changing handle updates displayName with it.
 */
export const patchMeBodySchema = z
    .object({
    handle: handleSchema.optional(),
    bio: z.string().trim().max(BIO_MAX_CHARS).nullable().optional(),
    homeRegion: ukRegionSchema.nullable().optional(),
    phoneE164: ukPhoneSchema.nullable().optional(),
    /** R2 key from POST /v1/social/uploads/presign with scope=avatar. */
    avatarR2Key: z.string().min(1).max(300).optional(),
})
    .strict();
export const changePasswordBodySchema = z.object({
    currentPassword: z.string().min(1).max(200),
    newPassword: passwordSchema,
});
export const registerDeviceBodySchema = z.object({
    platform: z.enum(['ios', 'android', 'web']),
    /** Which app registered the device (0060). Absent = community — every
     *  client that predates the work app is the community app. */
    app: z.enum(['community', 'work']).optional(),
    expoPushToken: z.string().min(1).max(200).nullable().optional(),
    deviceName: z.string().trim().max(80).nullable().optional(),
    appVersion: z.string().trim().max(20).nullable().optional(),
});
//# sourceMappingURL=user.js.map